import { OrderStatusEnum } from '../enums/order-status.enum';

import { isOneOf } from './DataHelpers';
import { INVALID_VALUE, NullableString } from './types';

export const mapOrderStatus = (orderStatus?: NullableString): string => {
  if (!orderStatus) return INVALID_VALUE;

  let result = '';
  const asArray = orderStatus.split(' ');
  asArray.forEach((word, index) => {
    result += (index > 0 ? ' ' : '') + word.charAt(0).toUpperCase() + word.substr(1);
  });

  return result;
};

export const isMessageSummaryAffectingStatus = (status?: NullableString): boolean => isOneOf(status, [
  OrderStatusEnum.Filled,
  OrderStatusEnum.PartiallyFilled,
  OrderStatusEnum.Rejected,
  OrderStatusEnum.Expired,
]);
